// @storybook-skip: internal section of ScreenHeaderBar; covered by its screen story
import { Pressable } from "react-native";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import type { ScreenHeaderAction } from "./types";

type Props = {
	action: ScreenHeaderAction;
	color: string;
	marginLeft?: number;
};

export const HeaderIconButton = ({ action, color, marginLeft }: Props) => {
	const theme = useAppTheme();

	return (
		<Pressable
			accessibilityLabel={action.accessibilityLabel}
			accessibilityRole="button"
			onPress={action.onPress}
			style={({ pressed }) => ({
				alignItems: "center",
				borderRadius: theme.roundness * 100,
				height: 40,
				justifyContent: "center",
				marginLeft,
				opacity: pressed ? 0.72 : 1,
				width: 40,
			})}
		>
			<AppIcon name={action.icon} size={24} color={color} />
		</Pressable>
	);
};
